export const apiKey = "072c30867a664bf27951890a08db787c";
export const urlBase = "https://api.themoviedb.org/3";
export const infoMenu = ["INFO", "CAST", "VIDEOS", "SIMILARS"];
export const personInfoMenu = ["INFO","CREDITS"]


